









































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import Loading from 'vue-loading-overlay';
import { Cart } from '@/models/cart';

import ListCart from './ListCart.vue';
import ConfirmModal from '@/shared/components/ConfirmModal.vue';

import commonService from '@/services/common-services';
import cartServices from '@/services/cart-services';
import authService from '@/services/auth-services';

import { APP_CONFIG } from '@/config/app-config';

@Component({
    components: {
        Loading,
        ListCart,
        ConfirmModal
    }
})
export default class ConfirmCart extends Vue {
    private feeBuyProRange: any;
    private isUseWallet = false;
    private isCheckPrice = true;
    private isConfirmWallet = false;
    private customerInfo: any = {};
    private isLoading = false;
    private confirmCart: any = {};
    private cartStatus = 0;
    private chinaStoreID = 0;
    private receivePlaceID = 0;

    get showMenu() {
        return this.$store.state[APP_CONFIG.stateKey.commonStore].showMenuLeft;
    }

    get userInfo() {
        return this.$store.state[APP_CONFIG.stateKey.authStore].userInfo;
    }
   
    get cartSelected(): Cart[] | null {
        return this.$store.state[APP_CONFIG.stateKey.cartState].cartSelected;
    }

    get warehouse() {
        return this.$store.state[APP_CONFIG.stateKey.commonStore].warehouse || [];
    }

    get chinaStore() {
        return this.$store.state[APP_CONFIG.stateKey.commonStore].chinaStore || [];
    }

    get feeGuarantee() {
        return this.$store.state[APP_CONFIG.stateKey.commonStore].feeGuarantee || [];
    } 

    private async getWarehouse() {
        const result = await commonService.getWarehouse();
        if (result && result.status === 200) {
            (window['getApp'] as any).$emit('SET_WAREHOUSE', result.data.data);
            this.syncStoreDefaults();
        }
    }

    private async getChinaStore() {
        const result = await commonService.getChinaStore();
        if (result && result.status === 200) {
            (window['getApp'] as any).$emit('SET_CHINASTORE', result.data.data);
            this.syncStoreDefaults();
        }
    }

    private async getFeeGuarantee() {
        const result = await commonService.getFeeGuarantee();
        if (result && result.status === 200) {
            (window['getApp'] as any).$emit('SET_FEEGUARANTEE', result.data.data);
        }
    }

    private syncStoreDefaults() {
        if (this.chinaStore && this.chinaStore.length > 0) {
            const hasChina = this.chinaStore.some((s: any) => s.ID === this.chinaStoreID);
            if (!hasChina) {
                this.chinaStoreID = this.chinaStore[0].ID;
            }
        }
        if (this.warehouse && this.warehouse.length > 0) {
            const hasWarehouse = this.warehouse.some((w: any) => w.ID === this.receivePlaceID);
            if (!hasWarehouse) {
                this.receivePlaceID = this.warehouse[0].ID;
            }
        }
    }

    @Watch('customerInfo', { immediate: true, deep: true })
    private async watchCustomerInfo() {
        if (this.customerInfo) {
            if (this.customerInfo.ChinaStoreID) {
                this.chinaStoreID = this.customerInfo.ChinaStoreID;
            }
            if (this.customerInfo.ReceivePlaceID) {
                this.receivePlaceID = this.customerInfo.ReceivePlaceID;
            }
            this.syncStoreDefaults();
        }
    }

    @Watch('chinaStore', { immediate: true, deep: true })
    private watchChinaStore() {
        this.syncStoreDefaults();
    }

    @Watch('warehouse', { immediate: true, deep: true })
    private watchWarehouse() {
        this.syncStoreDefaults();
    }

    private async onUpdateConfirm(eventData: any) {
        await this.loadData();
    }

    private async created() {
        if (!this.warehouse || this.warehouse.length === 0) {
            await this.getWarehouse();
        }
        if (!this.chinaStore || this.chinaStore.length === 0) {
            await this.getChinaStore();
        }
        if (!this.feeGuarantee || this.feeGuarantee.length === 0) {
            await this.getFeeGuarantee();
        }
        await this.getCustomersInfo();
        this.syncStoreDefaults();
        await this.loadData();
    }

    private async getCustomersInfo() {
        if (this.userInfo && this.userInfo.userId) {
            const result = await authService.customersInfo(this.userInfo.userId);
            if (result && result.status === 200) {
                this.customerInfo = result.data.data || {};
                (window['getApp'] as any).$emit('APP_SET_CUSTOMER_INFO', result.data.data || {});
            }
        }
    }

    private async loadData() {
        if (this.cartSelected === null || this.cartSelected.length === 0) {
            this.onComeback();
            return;
        }
        this.isLoading = true;
        const productIds = (this.cartSelected || []).flatMap(cart => (cart.products || []).map(pro => pro.id));
        let otherOptions: any[] = [];
        if (this.confirmCart && this.confirmCart.Orders) {
            otherOptions = this.confirmCart.Orders.map((cart: any) => ({
                ShopID: cart.OrderShopTempID,
                IsFragileGoods: cart.IsFragileGoods,
                IsCheck: cart.IsCheck,
                CheckFeeType: cart.CheckFeeType,
                IsFast: cart.IsFast,
                GuaranteeType: cart.GuaranteeType
            }));
        }
        
        const result = await cartServices.cartConfirm(productIds, otherOptions);
        if (result && result.status === 200) {
            this.confirmCart = result.data.data;
        }
        this.isLoading = false;
    }

    private onCloseModalWallet(eventData: any) {
        this.isConfirmWallet = !eventData.close || false;
    } 
    
    private onOtherModalWallet(eventData: any) {
        this.isConfirmWallet = !eventData.close || false;
        if (eventData.data === 'OK') {
            this.$router.push({ name: 'credit' });
        }
    }

    private onAcceptModalWallet(eventData: any) {
        this.isConfirmWallet = !eventData.close || false;
        if (eventData.data === 'OK') {
            this.pushData(false);
        }
    }

    private async submitData() {
        this.cartStatus = 0;
        if (this.isUseWallet === true) {
            if ((this.customerInfo.Wallet || 0) < (this.confirmCart.TotalDeposit || 0)) {
                this.isConfirmWallet = true;
                return;
            }
            this.cartStatus = 2;
        }

        this.pushData(this.isUseWallet);
    }

    private async pushData(isDeposit: boolean) {
        this.isLoading = true;
        const productIds = (this.cartSelected || []).flatMap(cart => (cart.products || []).map(pro => pro.id));
        const otherOptions = (this.confirmCart.Orders || []).map((cart: any) => ({
            ShopID: cart.OrderShopTempID,
            IsFragileGoods: cart.IsFragileGoods,
            IsCheck: cart.IsCheck,
            CheckFeeType: cart.CheckFeeType,
            IsFast: cart.IsFast,
            GuaranteeType: cart.GuaranteeType
        }));
        const result = await cartServices.bulk_action(productIds, otherOptions, isDeposit, this.chinaStoreID, this.receivePlaceID);
        if (result && result.data.status === 200 && result.data.message === 'Success') {
            await this.getCustomersInfo();
            Vue.notify({
                group: 'foo',
                type: 'success',
                title: 'Thông báo!',
                text: this.cartStatus === 2 ? 'Đơn hàng tạo thành công!' : 'Đơn hàng tạo thành công, vui lòng đặt cọc để mua hàng',
            });
            (window['getApp'] as any).$emit('SET_SELECTED_CART', null);
            this.$router.push({ name: 'order' });
            this.isLoading = false;
        } else {
            this.isLoading = false;
            Vue.notify({
                group: 'foo',
                type: 'error',
                title: 'Thông báo!',
                text: 'Có lỗi trong quá trình đặt hàng, vui lòng liên hệ quản trị!',
            });
        }
    }

    private onComeback() {
        this.$router.push({ name: 'cart-index' });
    }
}
